import styled from "styled-components";

export const FiltersContainerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  max-width: 1400px;
  padding-inline: 0;
`;

export const FiltersColumn = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex: 1;
`;

export const SearchContainer = styled.div`
  min-width: 200px;
`;

export const TableSwitcherColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
`;

export const TableSwitcherPlaceholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 40px;
`;

